import { render, staticRenderFns } from "./DetailGangguanLaluLintasPage.vue?vue&type=template&id=3ba1fbae"
import script from "./DetailGangguanLaluLintasPage.vue?vue&type=script&lang=js"
export * from "./DetailGangguanLaluLintasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports